"use client";
import React from "react";
import BannerImg1 from "@/assets/images/landingPageBanner/heroBanner.jpg";
import BannerMobileImg1 from "@/assets/images/landingPageBanner/mainDashBoardHeroBannerMobile.jpg";
import BannerImg2 from "@/assets/images/landingPageBanner/bannerImg2.jpg";
import BannerMobileImg2 from "@/assets/images/landingPageBanner/bannerImg2Mobile.jpg";
import BannerImg3 from "@/assets/images/landingPageBanner/4thJuly25HeroBannerDesktop.png";
import BannerMobileImg3 from "@/assets/images/landingPageBanner/4July25HeroBannerMobile.png";

import Link from "next/link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import LeftArrow from "@/icons/SliderLeftArrow";
import RightArrow from "@/icons/SliderRightArrow";
import Image from "next/image";
import {  useEffect, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";

function SampleNextArrow(props) {

  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <RightArrow />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <LeftArrow />
    </div>
  );
}


const DashboardBanner = () => {
  
  const dispatch = useDispatch();
  const updateBreadcrumb = (breadcrumb) => {
      dispatch(
        AddNewBreadcrum(breadcrumb)
      );
    };

  const images =  [
    {
      imageUrl:BannerImg1,
      redirectUrl: "/in-stock",
      breadcrumbName:"In Stock",
    },
    // {
    //   imageUrl:BannerImg2,
    //   redirectUrl: "/outlet",
    //   breadcrumbName:"Outlet",
    //  },
    // {
    //   imageUrl:BannerImg3,
    //   redirectUrl: "/next-day-delivery",
    //   breadcrumbName:"Next Day Delivery",
    //   },      
          
  ];

  const mobileImages =  [
     {
      imageUrl:BannerMobileImg1,
      redirectUrl: "/in-stock",
      breadcrumbName:"In Stock",
    },
    // {
    //   imageUrl:BannerMobileImg2,
    //   redirectUrl: "/outlet",
    //   breadcrumbName:"Outlet",
    // },
    // {
    //   imageUrl:BannerMobileImg3,
    //   redirectUrl: "/next-day-delivery",
    //   breadcrumbName:"Next Day Delivery",
    //   },    
  ];

  const [currentIndex, setCurrentIndex] = useState(1);
  const [totalSlides, setTotalSlides] = useState(images.length);

  useEffect(() => {
    setTotalSlides(images.length);
    setTotalSlides(mobileImages.length);

  }, [images.length,mobileImages.length]);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    appendDots: (dots) => <ul>{dots}</ul>,
    afterChange: (current) => setCurrentIndex(current + 1),
  };

  return (
    <CustomSlider>
      <Slider {...settings} className="sm:hidden">
        {images.map((data, index) => (
           <div key={index}>
            <AspectRatio ratio={ 1920 / 447}>
              <Link href={data.redirectUrl}
              onClick={()=> {
                updateBreadcrumb([{
                 name: data.breadcrumbName,
                 url: data.redirectUrl
               }])
              }}
              >
                <Image
                  className="w-full h-full object-cover"
                  src={data.imageUrl}
                  alt="banner"
                />
              </Link>
            </AspectRatio>
          </div>
        ))}
      </Slider>
      <Slider {...settings} className="hidden sm:block">
        {mobileImages.map((data, index) => (
           <div key={index}>
            <AspectRatio ratio={ 400 / 432 }>
              <Link href={data.redirectUrl}
              onClick={()=> {
                updateBreadcrumb([{
                 name: data.breadcrumbName,
                 url: data.redirectUrl
               }])
              }}
              >
                <Image
                  className="w-full h-full object-cover"
                  src={data.imageUrl}
                  alt="banner"
                />
              </Link>
            </AspectRatio>
          </div>
        ))}
      </Slider>
      <div className="count font-medium text-[17px] text-blue3 lg:text-[14px]">
        {currentIndex}/{totalSlides}
      </div>
    </CustomSlider>
  );
};

export default DashboardBanner;

const CustomSlider = styled.div`
  padding-bottom: 60px;
  position: relative;
  margin-bottom: 50px;
  .count {
    position: absolute;
    right: calc(-637px + 50vw);
    bottom: 16px;
    font-size: 14px;
  }
  .slick-dots {
    display: flex !important;
    max-width: 1228px;
    right: 0;
    left: 0;
    margin: 0 auto;
    bottom: -35px;
    right: 173px;
  }
  .slick-prev,
  .slick-next {
    top: unset;
    bottom: -74px;
    height: 43px;
    width: 43px;
    display: inline-flex !important;
    justify-content: center;
    align-items: center;
    &::before {
      display: none;
    }
  }
  .slick-prev {
    left: unset;
    right: calc(-591px + 50vw);
  }

  .slick-next {
    right: calc(-694px + 50vw);
  }
  .slick-dots li.slick-active button:before {
    opacity: 1;
    color: transparent;
    background-color: #000000;
    border-radius: 30px;
  }
  .slick-dots li {
    height: 4px;
    padding: 0;
    width: auto;
    flex: 1;
    margin: 0;

    button {
      font-size: 0;
      line-height: 0;
      height: 4px;
      width: 100%;
      margin: 0;
      &:before {
        font-size: 6px;
        line-height: 4px;
        height: 4px;
        opacity: 1;
        color: transparent;
        width: 100%;
        background: #d0d0d0;
      }
    }
  }

  @media (max-width: 1440px) {
    .count {
      right: 74px;
    }
    .slick-next {
      right: 15px;
    }
    .slick-dots {
      left: 20px;
      right: unset;
      max-width: calc(100% - 215px);
    }
    .slick-prev {
      right: 116px;
    }
  }
  @media (max-width: 1023px) {
    margin-bottom: 24px;
    .count {
      bottom: 17px;
    }
  }
  @media (max-width: 639px) {
    margin-bottom: 0;
    padding-bottom: 56px;
    .slick-prev,
    .slick-next {
      top: unset;
      bottom: -51px;
      height: 30px;
      width: 30px;
    }
    .slick-dots {
      bottom: -24px;
      max-width: calc(100% - 198px);
    }
    .count {
      bottom: 22px;
    }
    .mobile-view {
      > div {
        padding-bottom: 136% !important;
      }
    }
  }
`;